import Vuex from "vuex";
import Vue from "vue";
import Global from "../../utils/Global";
import api from "../../axios/api";
import {
  WantList,
  TravelList,
  userdetail,
  userModify,
  cityListCode,
  deleteTravel
} from "@/axios/service/travel.js";

Vue.use(Vuex);
const PersonalStore = {
  namespaced: true,
  state: {
    // provinceCode: "",
    // cityCode: "",
    // permanentCity: "",
    provinceObj: {},
    provinceOptions: [],
    cityOptions: [],
    areaOptions: [],
    draftList: [],
    draftListTotal: null,
    travelList: [],
    travelListTotal: null,
    wantList: [],
    wantListTotal: null,
    userdetailList: {},
    userModifyInformation: {},
    cityListCode: [],
    pushMessageAccount: 0 //后台推送消息数目
  },
  mutations: {
    resetPushMessageMutaion(state, value) {
      state.pushMessageAccount = value;
    },
    pushMessageMutation(state) {
      state.pushMessageAccount++;
    },
    cityListCodeMutations(state, value) {
       //移动端组件使用
      state.provinceObj = {};
      let province_list = {};
      let city_list = {};
      let county_list = {};
      if (value) {
        value.forEach( provinceEle => {
          let p_key = provinceEle.value;
          let p_value = provinceEle.label;
          province_list[p_key] = p_value;
          if (provinceEle.children) {
            provinceEle.children.forEach(cityEle => {
              let c_key = cityEle.value;
              //北京
              if (c_key === 110000) {
                c_key = 110100;
              }
              //天津
              if (c_key === 120000) {
                c_key = 120100;
              }
              //上海
              if (c_key === 310000) {
                c_key = 310100;
              }
              //重庆
              if (c_key === 500000) {
                c_key = 500100;
              }
              let c_value = cityEle.label;
              city_list[c_key] = c_value;
              if (cityEle.children) {
                cityEle.children.forEach(countryEle => {
                  let country_key = countryEle.value;
                  //![1100000,1200000,3100000,5000000].includes(country_key)
                  // 过滤掉“全市”对应的编码
                  if (country_key.toString().length !== 7) {
                    let country_value = countryEle.label;
                    county_list[country_key] = country_value;
                  }
                })
              }
            });
          }
        });
      }
      state.provinceObj.province_list = province_list;
      state.provinceObj.city_list = city_list;
      state.provinceObj.county_list = county_list;
      state.provinceOptions = [];
      state.cityListCode = value; //页面中级联选择器使用
      for (let i = 0; i < value.length; i++) {
        state.provinceOptions.push({
          label: value[i].label,
          value: value[i].value,
          children: value[i].children
        });
      }
    },
    cityOptionsMutations(state, value) {
      state.cityOptions = [];
      state.areaOptions = [];
      for (let i = 0; i < state.provinceOptions.length; i++) {
        if (state.provinceOptions[i].value == value.provinceCode) {
          for (let j = 0; j < state.provinceOptions[i].children.length; j++) {
            state.cityOptions.push({
              label: state.provinceOptions[i].children[j].label,
              value: state.provinceOptions[i].children[j].value,
              children: state.provinceOptions[i].children[j].children
            });
          }
        }
      }
    },
    areaOptionsMutations(state, value) {
      state.areaOptions = [];
      for (let m = 0; m < state.cityOptions.length; m++) {
        if (value.cityCode == state.cityOptions[m].value) {
          for (let n = 0; n < state.cityOptions[m].children.length; n++) {
            state.areaOptions.push({
              label: state.cityOptions[m].children[n].label,
              value: state.cityOptions[m].children[n].value,
              children: state.cityOptions[m].children[n].children
            });
          }
        }
      }
    },

    draftListMutations(state, value) {
      state.draftList = value;
    },
    draftListTotalMutations(state, value) {
      state.draftListTotal = value;
    },
    travelListMutations(state, value) {
      state.travelList = value;
      state.draftList = value;
    },
    travelListTotalMutations(state, value) {
      state.travelListTotal = value;
      state.draftListTotal = value;
    },
    wantListMutations(state, value) {
      state.wantList = value;
    },
    wantListTotalMutations(state, value) {
      state.wantListTotal = value;
    },
    userdetailMutations(state, value) {
      state.userdetailList = value;
    },
    userModifyMutations(state, value) {
      state.userModifyInformation = value;
    },
    userAvatarMutations(state, value) {
      let data = Object.assign({},{avatar:value})
      state.userdetailList = data;
    }
  },
  actions: {
    findDraftList(context, params) {
      var params = params;
      TravelList(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          if(json.data.data.length===0&&params.page!==1){
            --params.page;
            context.dispatch("findDraftList",params);
          }
          context.commit("draftListMutations", json.data.data);
          context.commit("draftListTotalMutations", json.data.total);
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    },
    //获取用户信息
    getUserdetail(context, params) {
      userdetail(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          context.commit("userdetailMutations", json.data);
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    },
    //修改个人信息
    getuserModify(context, params) {
      let vueParam = params.vue;
      delete params.vue;
      const saveAfter = () => {
        vueParam.showSaveResult = true;
        //3s后使保存结果消失
        vueParam.timeOut = setTimeout(() => {
          vueParam.showSaveResult = false;
        }, 3000);
      };
      userModify(params).then(json => {
        if (json.respCode === 100) {
          context.commit("userModifyMutations", json.data);
          context.dispatch("getUserdetail", params);
          vueParam.saveResult = "保存成功";
          saveAfter();
          // Global.messageSuc("修改个人信息成功!");
        } else if (json.respCode === -100) {
          vueParam.saveResult = "保存失败";
          saveAfter();
          // Global.messageErr("服务器发生错误!");
        } else if (json.respCode === -102) {
          vueParam.saveResult = "保存失败";
          saveAfter();
          // Global.messageErr("缺失参数!");
        } else if (json.respCode === -500) {
          vueParam.saveResult = "保存失败";
          saveAfter();
          // Global.messageErr("该条数据不存在!");
        } else if (json.respCode === -117) {
          vueParam.saveResult = "保存失败";
          saveAfter();
          Global.messageErr("用户名称重复!");
        }
      });
    },
    //查询城市code
    getCityListCode(context, params) {
      cityListCode(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          context.commit("cityListCodeMutations", json.data.provinces);
          context.dispatch("getUserdetail", params);
        } else {
          context.dispatch("getUserdetail", params);
          // Global.messageErr('获取列表失败');
        }
      });
    },
    //删除游记
    getdeleteTravel(context, params) {
      let returnPromise = new Promise((resolve, reject) => {
        deleteTravel(params).then(json => {
          resolve(json);
        });
      });
      return returnPromise;
    }
  }
};

export default PersonalStore;
